export enum UserRole {
  Admin = 'admin',
  Operator = 'operator',
  Trader = 'trader',
  Merchant = 'merchant',
  TechOperator = 'tech_operator',
}
